import {ColorPairTO} from 'generated/JavaTO'

export enum BSApiAction {
	GET = 'get',
	SAVE = 'save',
	DELETE = 'delete',
	GEN = 'gen',
	ABL = 'abl',
}

export const BSApiActionLocaleDict: { [key in BSApiAction]: string } = {
	[BSApiAction.GET]: 'Lesen',
	[BSApiAction.SAVE]: 'Sichern',
	[BSApiAction.DELETE]: 'Löschen',
	[BSApiAction.GEN]: 'Genehmigen',
	[BSApiAction.ABL]: 'Ablehnen',
} as const

export const BSApiActionColorDict: { [key in BSApiAction]: ColorPairTO } = {
	[BSApiAction.GET]: {bgColor:'#3276ff', textColor:'#fff'},
	[BSApiAction.SAVE]: {bgColor: '#3ebe28', textColor:'#fff'},
	[BSApiAction.DELETE]: {bgColor: '#df3d3d', textColor:'#fff'},
	[BSApiAction.GEN]: {bgColor: '#a3fac3', textColor:'#000'},
	[BSApiAction.ABL]: {bgColor: '#ffa9a9', textColor:'#000'},
} as const